import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const VanFleet2: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m210 430h30v134.33h-30z' />
    <path d='m510 764.33c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m120 764.33c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m160 689.33h305v30h-305z' />
    <path d='m20 559.33h195v30h-195z' />
    <path d='m210 659.33v-120s30 0 30 0v90c0 16.57-13.43 30-30 30z' />
    <path d='m630 719.33h-65v-30h35v-195c0-24.81-20.19-45-45-45h-446.89l-70.78 108.25c-4.8 7.34-7.34 15.86-7.34 24.63v107.13h45v30h-74.99v-137.13c0-14.62 4.23-28.81 12.23-41.04l79.66-121.83h463.11c41.36 0 75 33.65 75 75v225z' />
    <path d='m360 41.84h30v134.33h-30z' />
    <path d='m660 376.17c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m270 376.17c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30z' />
    <path d='m310 301.17h305v30h-305z' />
    <path d='m170 171.17h195v30h-195z' />
    <path d='m360 271.17v-120s30 0 30 0v90c0 16.57-13.43 30-30 30z' />
    <path d='m780 331.17h-65v-30h35v-195c0-24.81-20.19-45-45-45h-446.89l-70.78 108.25c-4.8 7.34-7.34 15.86-7.34 24.63v107.13h45v30h-75v-137.13c0-14.62 4.23-28.81 12.23-41.04l79.67-121.84h463.11c41.36 0 75 33.65 75 75z' />
  </IconBase>
));

VanFleet2.displayName = 'VanFleet2';

export default VanFleet2;
